import apiHeader from '@/helpers/apiHeader';

const priorityService = {
  list(page, params) {
    return apiHeader.get('priorities?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('priorities/' + id);
  },
};

export default priorityService;
